export function useGuestplan(options: { accessKey: string; open?: boolean }) {
	const { locale } = useI18n();

	const scriptId = 'guestplan-widget-sdk';
	const scriptSrc = 'https://cdn.guestplan.com/widget.js';

	const destroyGuestplan = () => {
		const host = document.getElementById('gstpln-widget-host');
		if (host) {
			host.remove();
		}

		const sdk = document.getElementById(scriptId);
		if (sdk) {
			sdk.remove();
		}
	};

	const mountGuestplan = () => {
		if (document.getElementById(scriptId)) {
			return;
		}

		window._gstpln = window._gstpln || {};
		window._gstpln.accessKey = options.accessKey;
		window._gstpln.open = options.open ?? false;
		window._gstpln.locale = locale.value;
		window._gstpln.usePartySizeBreakdown = true;

		const script = document.createElement('script');
		script.id = scriptId;
		script.async = true;
		script.src = scriptSrc;

		document.body.appendChild(script);
	};

	onMounted(() => {
		mountGuestplan();

		watch(
			() => locale.value,
			async () => {
				destroyGuestplan();
				await nextTick();
				mountGuestplan();
			},
		);
	});

	onBeforeUnmount(() => {
		destroyGuestplan();
	});
}
